import { Component, Input, inject } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroupDirective } from '@angular/forms';
import { distinctUntilChanged, filter } from 'rxjs';
import { DictionaryItem } from 'src/app/models/dictionary-item';
import { SubSink } from 'SubSink';

@Component({
  selector: 'app-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrl: './select-filter.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: false
})
export class SelectFilterComponent {
  formGroupDirective = inject(FormGroupDirective);

  @Input() name: string;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() multiple?: boolean;
  @Input() datasource: DictionaryItem[];
  @Input() changeCallback: (id: number) => void;
  @Input() description?: string;

  private readonly subs = new SubSink();
  private get control(): AbstractControl {
    return this.formGroupDirective.form.get(this.name);
  }

  constructor() { }

  ngOnInit(): void {
    this.addControl();

    this.subs.sink = this.control.valueChanges.pipe(filter(() => !!this.changeCallback)).subscribe((value) => this.changeCallback(value));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.removeControl();
  }

  private addControl(): void {
    this.formGroupDirective.form.addControl(this.name, this.multiple ? new FormControl([]) : new FormControl(null), { emitEvent: false });
  }

  private removeControl(): void {
    this.formGroupDirective.form.removeControl(this.name, { emitEvent: false });
  }
}
